import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

// import "primereact/resources/primereact.min.css";
// import "primeicons/primeicons.css";

function BasicExample() {
  const navigate = useNavigate();

  return (
    <Navbar expand="lg" className="custom-navbar shadow-sm py-3">
      <Container>
        <Navbar.Brand
          as={Link}
          to="/"
          style={{
            fontWeight: "bold",
            fontSize: "1.5rem",
            color: "#ffffff",
          }}
        >
          📁 Files
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/STI" className="nav-item-custom">
              STI
            </Nav.Link>
            <Nav.Link as={Link} to="/VPD1" className="nav-item-custom">
              VPD1
            </Nav.Link>
            <Nav.Link as={Link} to="/VPD2" className="nav-item-custom">
              VPD2
            </Nav.Link>
            <Nav.Link as={Link} to="/WBD" className="nav-item-custom">
              WBD
            </Nav.Link>
            <Nav.Link as={Link} to="/OTH1" className="nav-item-custom">
              OTH1
            </Nav.Link>
            <Nav.Link as={Link} to="/OTH2" className="nav-item-custom">
              OTH2
            </Nav.Link>
            <Nav.Link as={Link} to="/HMG" className="nav-item-custom">
              HMG
            </Nav.Link>
            <Nav.Link as={Link} to="/FBD" className="nav-item-custom">
              FBD
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>

      <style>{`
        .custom-navbar {
          background: linear-gradient(to right, #4facfe, #00f2fe);
        }

        .nav-item-custom {
          position: relative;
          font-weight: 500;
          color: #ffffff !important;
          transition: color 0.3s ease;
        }

        .nav-item-custom:hover {
          color: #000000 !important;
        }

        .nav-item-custom::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          width: 0%;
          height: 2px;
          background-color: #ffffff;
          transition: width 0.3s ease;
        }

        .nav-item-custom:hover::after {
          width: 100%;
        }
      `}</style>
    </Navbar>
  );
}

export default BasicExample;
